/** JWT token 存储 key */
export const JWT_TOKEN_KEY = 'jwt_token';

/** 用户信息存储 key */
export const USER_INFO_KEY = 'user_info';

/** 用户信息类型 */
export interface UserInfo {
  id: number;
  username: string;
  role?: string;
}

/** 登录请求参数 */
export interface LoginParams {
  username: string;
  password: string;
}

/** 登录响应数据 */
export interface LoginResult {
  token: string;
  user: UserInfo;
}

/** 仪表盘聚合数据 */
export interface DashboardStats {
  totalBooks: number;
  borrowedCount: number;
  overdueCount: number;
  todayTransactions: number;
}
